// extracted by mini-css-extract-plugin
module.exports = {"content":"e_af","pw-ad-scroll-container":"e_bf","pw-in-article":"e_cf"};